<template lang="pug">
  section
    transition( name="description" )
      .container( v-if="step===1" )
        .description
          p.en {{ days }}:{{ hours }}:{{ minutes }}:{{ seconds }} passed
            br
            | since the new year began.
          p.jp 新しい年が始まって {{ days }} 日 {{ hours }} 時間 {{ minutes }} 分 {{ seconds }} 秒 経ちました。
        .menu
          .btn( @click="onNext" ) 
            p NEXT

    transition( name="description" )
      .container( v-if="step===2" )
        .description
          p.en What kind of year
            br
            | would you like to do in 2019?
          p.jp 2019年はどんな年にしたいですか？
        .menu
          .btn( @click="onFix" ) 
            p NEXT
</template>

<script>
export default {
  data() {
    return {
      status: true,
      dateStart: new Date(2019, 0, 1),
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      step: 0
    };
  },

  mounted() {
    this.step = 1;
    this.checkDate();
  },

  methods: {
    checkDate() {
      let dateCurrent = new Date();
      let ms = dateCurrent.getTime() - this.dateStart.getTime();

      this.seconds = Math.floor(ms / 1000);
      this.minutes = Math.floor(this.seconds / 60);
      this.hours = Math.floor(this.minutes / 60);
      this.days = Math.floor(this.hours / 24);

      this.seconds = this.seconds - this.minutes * 60;
      this.minutes = this.minutes - this.hours * 60;
      this.hours = this.hours - this.days * 24;

      if (this.seconds < 10) this.seconds = "0" + this.seconds;
      if (this.minutes < 10) this.minutes = "0" + this.minutes;
      if (this.hours < 10) this.hours = "0" + this.hours;

      setTimeout(() => {
        if (this.status) this.checkDate();
      }, 1000);
    },

    onNext() {
      this.step++;
    },

    onFix() {
      this.$emit("onFix");
    }
  },

  beforeDestory() {
    //setTimeoutの解除
    this.status = false;
  }
};
</script>

<style scoped lang="scss">
</style>
